import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AjaxContext, AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { dehydrateFormData } from '../../utils/formDataParser';
import { ICustomResponse, ITDSConfig, ISegmentConfigData } from '../../utils/type';
import { GET_CONFIG_URI } from '../../../tdsHelper';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const history = useHistory();
	const { requestUpdateConfig } = useService();
	const [configData, setConfigData] = useState<ITDSConfig | {}>({
		liveSegmentList: [],
		userSegmentList: [],
		isEnabled: true,
		isLiveSegmentEnabled: true,
		customAbsorptionAmount: 0,
		firstWithdrawalAbsorptionEnabled: true
	});

	const updateConfig = (tdsConfig: ISegmentConfigData) => {
		setShowLoader(true);
		requestUpdateConfig(appName, { ...tdsConfig }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the TDS config', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Config Updated');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const fetchPriorityData = async (): Promise<void> => {
		try {
			setShowLoader(true);
			const result: { data: any } = await postData({
				endpoint: GET_CONFIG_URI,
				body: {},
				queryParams: {
					appName
				}
			});
			if (!result?.data?.success) throw new Error('Error in fetching the priority list!');
			const data: ISegmentConfigData = result?.data?.data;
			setConfigData(data);
			return;
		} catch (error) {
			showAlert('Error in fetching the priority list', { type: 'error' });
			throw error;
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		fetchPriorityData();
	}, []);

	const handleFormSubmit = (submittedData: ISegmentConfigData) => {
		updateConfig(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};
	return {
		configData,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
